import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const LoyaltyPage = () => <ModuleDetailPage moduleId="loyalty" />;

export default LoyaltyPage;
